import { useContext } from 'react';
import AuthContext from 'src/contexts/Auth';

const useAuth = () => useContext(AuthContext);

export default useAuth;
